import axios from 'axios'
const apiUrl =
    process.env.NODE_ENV === 'production'
        ? '/api'
        : process.env.REACT_APP_API_URL
// Get one specific thing, based on its id
export const fetchDatabase = async () => {
    const response = await axios.get(`${apiUrl}/database`)
    return response.data
}
